<template>
  <div>
    <recommended-view />
  </div>
</template>

<script>
import RecommendedView from './RecommendedView'

export default {
  name: 'VideoOfflineChat',
  components: {
    RecommendedView
  }
}
</script>
